import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card shadow my-3" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table table-hover align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", { class: "thead-loupey" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-start",
      scope: "col"
    }, "Id"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-start",
      scope: "col"
    }, "Status")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"m-3\"><nav aria-label=\"\"><div class=\"pagination pagination-sm justify-content-end\"><div class=\"page-item\"><a class=\"page-link\" href=\"#\">Previous</a></div><div class=\"page-item\"><a class=\"page-link\" href=\"#\">1</a></div><div class=\"page-item\"><a class=\"page-link\" href=\"#\">2</a></div><div class=\"page-item\"><a class=\"page-link\" href=\"#\">3</a></div><div class=\"page-item\"><a class=\"page-link\" href=\"#\">Next</a></div></div></nav></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_table_row = _resolveComponent("table-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_loading, {
        active: !_ctx.isLoaded,
        isErrored: _ctx.isErrored,
        "is-full-page": false,
        onRetryRequested: _ctx.fetchData,
        errorMessage: _ctx.errorMessage
      }, null, 8, ["active", "isErrored", "onRetryRequested", "errorMessage"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subscriptions, (subscription) => {
              return (_openBlock(), _createBlock(_component_table_row, {
                key: subscription.id,
                id: subscription.id,
                status: subscription.status
              }, null, 8, ["id", "status"]))
            }), 128))
          ])
        ])
      ]),
      _hoisted_6
    ])
  ]))
}